import { Logo } from "@/components/Logo";
import { HomeShot } from "@/components/HomeShot";
import { brand, hosts } from "@/lib/env";

/** Sign-up and login share this: the form on the left, the product on the right. Todoist's shape, Lifeable's skin. */
export function AuthShell({ title, lead, children }: { title: string; lead?: string; children: React.ReactNode }) {
  return (
    <div className="flex-1 grid lg:grid-cols-[minmax(0,1fr)_minmax(0,1.1fr)] lg:h-dvh lg:overflow-hidden">
      <div className="px-6 sm:px-14 py-8 sm:py-10 flex flex-col min-h-dvh lg:min-h-0 lg:h-dvh lg:overflow-y-auto">
        <Logo size={28} href={hosts.www} />
        <div className="my-auto w-full max-w-[400px] pt-12 pb-10">
          <h1 className="text-[32px] sm:text-4xl font-bold tracking-tight">{title}</h1>
          {lead ? <p className="mt-2 text-muted">{lead}</p> : null}
          <div className="mt-8">{children}</div>
        </div>
        <p className="text-xs text-muted">© {new Date().getFullYear()} {brand.legalName} · <a href={`${hosts.www}/privacy`} className="hover:text-ink">Privacy</a> · <a href={`${hosts.www}/terms`} className="hover:text-ink">Terms</a></p>
      </div>
      <div className="hidden lg:flex flex-col items-center justify-center p-10 h-dvh overflow-hidden bg-[radial-gradient(900px_600px_at_20%_10%,#e4e6ff_0%,#f5f7ff_50%,#ffffff_100%)] border-l border-line">
        <div className="origin-center scale-[.88] xl:scale-100 drop-shadow-[0_30px_60px_rgba(79,82,224,0.18)]"><HomeShot compact /></div>
        <div className="mt-6 text-center max-w-sm">
          <div className="text-2xl font-bold tracking-tight">{brand.headline}</div>
          <div className="mt-1.5 text-muted">{brand.sub}</div>
        </div>
      </div>
    </div>
  );
}

export function GoogleIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true" className="shrink-0">
      <path fill="#EA4335" d="M24 9.5c3.5 0 6.6 1.2 9 3.5l6.7-6.7C35.6 2.5 30.2 0 24 0 14.6 0 6.5 5.4 2.6 13.3l7.8 6C12.3 13.6 17.7 9.5 24 9.5z"/>
      <path fill="#4285F4" d="M46.5 24.5c0-1.6-.1-3.1-.4-4.5H24v9h12.7c-.6 3-2.3 5.5-4.8 7.2l7.5 5.8c4.4-4.1 7.1-10.1 7.1-17.5z"/>
      <path fill="#FBBC05" d="M10.4 28.7A14.5 14.5 0 0 1 9.5 24c0-1.6.3-3.2.8-4.7l-7.8-6A24 24 0 0 0 0 24c0 3.9.9 7.5 2.6 10.7l7.8-6z"/>
      <path fill="#34A853" d="M24 48c6.5 0 11.9-2.1 15.9-5.8l-7.5-5.8c-2.1 1.4-4.9 2.3-8.4 2.3-6.3 0-11.7-4.1-13.6-9.9l-7.8 6C6.5 42.6 14.6 48 24 48z"/>
    </svg>
  );
}
